import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Button, Form, InputGroup } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import google from "../assets/images/google.png";
import facebook from "../assets/images/facebook.png";

const SignupForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    cpassword: "",
    remember: false,
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showcPassword, setShowcPassword] = useState(false);
  const [errors, setErrors] = useState({
    name: "",
    email: "",
    password: "",
    cpassword: "",
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // Basic email validation function
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email.trim()); // Trim spaces before validation
  };

  // Signup form submission with validation
  const handleSignup = async (e) => {
    e.preventDefault();
    let validationErrors = {};

    // Name validation
    if (!formData.name.trim()) {
      validationErrors.name = "Name is required.";
    }

    // Email validation
    if (!formData.email.trim()) {
      validationErrors.email = "Email is required.";
    } else if (!validateEmail(formData.email)) {
      validationErrors.email = "Please enter a valid email address.";
    }

    // Password validation
    if (!formData.password.trim()) {
      validationErrors.password = "Password is required.";
    }

    // Confirm password validation
    if (!formData.cpassword.trim()) {
      validationErrors.cpassword = "Confirm Password is required.";
    } else if (formData.password !== formData.cpassword) {
      validationErrors.cpassword = "Passwords do not match.";
    }

    // If there are validation errors, update state and prevent form submission
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    // Simulate successful signup and store login status
    localStorage.setItem("isLoggedIn", true);

    // Redirect to the home page
    navigate("/");
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const togglecPasswordVisibility = () => {
    setShowcPassword((prev) => !prev);
  };

  return (
    <div className="login-box">
      <h2>Create an account</h2>
      <p>Gateway to tailored medical insights and supportive community.</p>

      <Form onSubmit={handleSignup} className="form login-form">
        <Form.Group className="mb-4">
          <Form.Label>Name</Form.Label>
          <Form.Control
            type="text"
            name="name"
            placeholder="Enter name"
            value={formData.name}
            onChange={handleChange}
            isInvalid={!!errors.name} // Ensure invalid state is set for name
          />
          <Form.Control.Feedback type="invalid">
            {errors.name}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group className="mb-4">
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="text"
            name="email"
            placeholder="Email address"
            value={formData.email}
            onChange={handleChange}
            isInvalid={!!errors.email} // Ensure invalid state is set for email
          />
          <Form.Control.Feedback type="invalid">
            {errors.email}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group className="password-field mb-3">
          <Form.Label>Password</Form.Label>
          <div className={`input-group ${errors.password ? "is-invalid" : ""}`}>
            <Form.Control
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
              isInvalid={!!errors.password} // Ensure invalid state is set for password
              className="form-control"
            />
            <InputGroup.Text
              onClick={togglePasswordVisibility}
              className="eye-icon"
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </InputGroup.Text>
          </div>
          {errors.password && (
            <div className="invalid-feedback">{errors.password}</div>
          )}
        </Form.Group>

        <Form.Group className="password-field mb-3">
          <Form.Label>Confirm password</Form.Label>
          <div
            className={`input-group ${errors.cpassword ? "is-invalid" : ""}`}
          >
            <Form.Control
              type={showcPassword ? "text" : "password"}
              name="cpassword"
              placeholder="Confirm Password"
              value={formData.cpassword}
              onChange={handleChange}
              isInvalid={!!errors.cpassword} // Ensure invalid state is set for confirm password
              className="form-control"
            />
            <InputGroup.Text
              onClick={togglecPasswordVisibility}
              className="eye-icon"
            >
              {showcPassword ? <FaEyeSlash /> : <FaEye />}
            </InputGroup.Text>
          </div>
          {errors.cpassword && (
            <div className="invalid-feedback">{errors.cpassword}</div>
          )}
        </Form.Group>

        <div className="form-options d-flex justify-content-between">
          <Form.Check
            type="checkbox"
            label={
              <>
                By signing up, I agree to the{" "}
                <Link to="/terms" className="terms-link">
                  Terms & Conditions
                </Link>
                .
              </>
            }
            name="remember"
            checked={formData.remember}
            onChange={handleChange}
            className="custom-checkbox"
          />
        </div>

        <Button type="submit" className="full-btn sign-in-btn w-100">
          Sign up
        </Button>
      </Form>
      <div className="or-divider or-divider-signup">
        <div>
          <span>or Sign in with Email</span>
        </div>
      </div>
      <div className="social-login-buttons social-signup-buttons">
        <button className="google-btn">
          <img src={google} alt="Google Logo" className="google-logo" />
          Google
        </button>

        <button className="facebook-btn">
          <img src={facebook} alt="Facebook Logo" className="facebook-logo" />
          Facebook
        </button>
      </div>
      <p className="register-link">
        Already have an account? <Link to="/login">Login</Link>
      </p>
    </div>
  );
};

export default SignupForm;
